import { useId } from 'react';

import styles from './Checkbox.scss';

const Checkbox = ({
    name,
    label,
    'aria-label': ariaLabel,
    value,
    onChange,
    ref,
}) => {
    const id = useId();
    return (
        <label className={styles.label} htmlFor={id} aria-label={ariaLabel}>
            <input
                ref={ref}
                id={id}
                className={styles.checkbox}
                type='checkbox'
                name={name}
                checked={value}
                onChange={onChange}
            />
            <div className={styles['checkbox-image']}>
                <div className={styles['checkbox-icon']} />
            </div>
            <div className={styles.checkbox__text}>{label}</div>
        </label>
    );
};

export default Checkbox;
